import { expositionOrderPreviewSchema } from "../schemas";
import {
  makeAnyKeySelector,
  makeCollectionSelector,
  makeAnyKeyCollectionSelector,
  makeFetchStatusSelector,
} from "./collections";

export const DEFAULT_COLLECTION = "index";

export function makeViewAnyKeySelector(key, collection) {
  return makeAnyKeySelector(key, collection, expositionOrderPreviewSchema);
}

export function makeExpositionOrderPreviewsSelector(collection = DEFAULT_COLLECTION) {
  return makeCollectionSelector(collection, expositionOrderPreviewSchema);
}

export function makeExpositionOrderPreviewsAnyKeySelector(key, collection = DEFAULT_COLLECTION) {
  return makeAnyKeyCollectionSelector(key, collection, expositionOrderPreviewSchema);
}

export function makeExpositionOrderPreviewsFetchStatusSelector(collection = DEFAULT_COLLECTION) {
  return makeFetchStatusSelector(collection, expositionOrderPreviewSchema);
}
